import { render, staticRenderFns } from "./CorporateDiningROI.vue?vue&type=template&id=61cd497e&scoped=true"
import script from "./CorporateDiningROI.vue?vue&type=script&lang=js"
export * from "./CorporateDiningROI.vue?vue&type=script&lang=js"
import style0 from "./CorporateDiningROI.vue?vue&type=style&index=0&id=61cd497e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd497e",
  null
  
)

export default component.exports